
import React from 'react';

interface TeamCardHeaderProps {
  displayName: string;
  description?: string;
}

const TeamCardHeader = ({ displayName, description }: TeamCardHeaderProps) => {
  return (
    <div className="mb-3">
      <h2 className="text-xl font-semibold text-white">{displayName}</h2>
      <p className="text-gray-400 text-sm mt-1 line-clamp-2">{description || "No description"}</p>
    </div>
  );
};

export default TeamCardHeader;
